export default __webpack_public_path__ + "assets/canadianAppartment.842ea402.png";